exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-line-material {\n    top: 0  ;\n    position: relative;\n    margin: auto;\n    width: 100%;\n}\n\n.sk-line-material .sk-child {\n    width: 100%;\n    height: 4px;\n    position: absolute;\n    top:0;\n    display: inline-block;\n    transform-origin: 0% 0%;\n    animation: sk-line-material 2s ease-in-out 0s infinite both;\n}\n\n@keyframes sk-line-material {\n    0% {\n        transform: scaleX(0);\n    }\n    100% {\n        transform: scaleX(1);\n    }\n}\n\n#http-loader {\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    z-index: 9999;\n}\n\n.loader-bg {\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    filter: alpha(opacity=70);\n    opacity: 1;\n    background-color: rgba(0,0,0,0);\n}\n\n.colored-parent, .colored > div {\n    background-color: rgba(26, 188, 156, 0.80);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/spinner/spinkit-css/sk-line-material.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-line-material.css
// module chunks = main